import React, {useContext} from "react";
import parse from 'html-react-parser'; // This Method use to convert Raw-Html string into HTML Elements.
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import {Modal} from "react-bootstrap";

export default () => {
    let Record = useContext(RecordsManagementContext)
    return (
        <>
            {Record.CP_PageDetails.ScheduledEvents.map((event) => {
                return (
                    <div className="content-p mt-1">
                        <p className="mb-0" style={{padding: "0%"}}>
                            <table className="table estimated-cost-tbl description" style={{margin: "0" , padding:"0.5rem"}}>
                                { !Record.CP_PageDetails.hideScheduledInfo && <tr>
                                    <td>{event.Scheduled}</td>
                                    {Record.CP_PageDetails.EstimateStatistics.ArrivalTime?
                                    <td>{event.Time}</td> : ""}
                                    <td>{event.JobName}</td>
                                    <td>{event.Hours}</td>
                                    {!Record.CP_PageDetails.HideSchedulePrice && <td>{event.Cost}</td>}
                                </tr>}
                                <tr style={{background: "white"}}>
                                    <td colSpan="5" style={{textAlign: "left"}} title={event.Comment}>{event.Comment}</td>
                                </tr>
                            </table>
                        </p>
                    </div>
                )
            })}
        </>
    );
}